<template>
  <div>
    <v-btn
      v-if="showInstallButton && isAllowedPage"
      color="primary"
      small
      class="install-pwa-btn mr-2"
      @click="installPwa"
    >
      <v-icon left>mdi-cellphone-arrow-down</v-icon>
      Install App
    </v-btn>
    <!-- <v-btn
      color="primary"
      small
      class="install-pwa-btn mr-2"
      @click="installPwa"
    >
      <v-icon left>mdi-cellphone-arrow-down</v-icon>
      Install
    </v-btn> -->
    
    <!-- Installation Instructions Dialog -->
    <v-bottom-sheet
      v-model="showInstructions"
      inset
      max-width="600"
      persistent
      content-class="install-dialog-bottom"
    >
      <v-card class="install-dialog-card">
        <v-card-title class="headline py-2">
          Install Meal Guide App
          <v-spacer></v-spacer>
          <v-btn icon @click="showInstructions = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-2">
          <div v-if="isIOS">
            <p class="mb-2">To install this app on your iOS device:</p>

            {{ isOnEdge }}

            <v-card flat class="mb-2" v-if="isOnEdge">
              <v-card-text class="py-1">
                <ol class="instruction-list">
                  <li>Copy the client ID 
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-btn
                          v-show="!mdUp"
                          v-on="on"
                          class="white--text"
                          :disabled="!folderId"
                          :style="{ backgroundColor: user?.brandColor || '#97c81f' }"
                          small
                          @click="copyFolderID(folderId)"
                          depressed
                        >
                          <v-icon small>mdi-content-copy</v-icon>
                          Client ID
                        </v-btn>
                      </template>
                      <span>Copy Client ID</span>
                    </v-tooltip>
                  </li>
                  <li>Tap menu<v-icon small>mdi-menu</v-icon>in the bottom-right corner</li>
                  <li>Swite up and tap Share<v-icon small>mdi-export-variant</v-icon></li>
                  <li>Swipe up and tap Add to Home Screen<v-icon small>mdi-plus-box-outline</v-icon></li>
                  <li>The app will appear on your home screen</li>
                </ol>
              </v-card-text>
            </v-card>
            
            <v-card flat class="mb-2" v-else>
              <v-card-text class="py-1">
                <ol class="instruction-list">
                  <li>Copy the client ID 
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-btn
                          v-show="!mdUp"
                          v-on="on"
                          class="white--text"
                          :disabled="!folderId"
                          :style="{ backgroundColor: user?.brandColor || '#97c81f' }"
                          small
                          @click="copyFolderID(folderId)"
                          depressed
                        >
                          <v-icon small>mdi-content-copy</v-icon>
                          Client ID
                        </v-btn>
                      </template>
                      <span>Copy Client ID</span>
                    </v-tooltip>
                  </li>
                  <li>Tap the Share button <v-icon small>mdi-export-variant</v-icon> at the bottom of the screen</li>
                  <li>Scroll down and tap "Add to Home Screen" <v-icon small>mdi-plus-box-outline</v-icon></li>
                  <li>Tap "Add" in the top-right corner</li>
                  <li>The app will appear on your home screen</li>
                </ol>
              </v-card-text>
            </v-card>
            
            <v-card flat>
              <v-slide-group
                v-model="iosStep"
                class="pa-0"
                show-arrows
              >
                <v-slide-item
                  v-for="n in 4"
                  :key="n"
                  v-slot="{ toggle }"
                >
                  <div 
                    class="mx-1 step-image-container"
                    @click="toggle"
                  >
                    <v-img
                      :src="`/source/iphone/${n}.jpg`"
                      height="180"
                      width="140"
                      contain
                      class="mx-auto rounded"
                    ></v-img>
                  </div>
                </v-slide-item>
              </v-slide-group>
            </v-card>
          </div>
          
          <div v-else-if="isAndroid">
            <p class="mb-2">To install this app on your Android device:</p>
            
            <v-card flat class="mb-2">
              <v-card-text class="py-1">
                <ol class="instruction-list">
                  <li>Copy the client ID 
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-btn
                          v-show="!mdUp"
                          v-on="on"
                          class="white--text"
                          :disabled="!folderId"
                          :style="{ backgroundColor: user?.brandColor || '#97c81f' }"
                          small
                          @click="copyFolderID(folderId)"
                          depressed
                        >
                          <v-icon small>mdi-content-copy</v-icon>
                          Client ID
                        </v-btn>
                      </template>
                      <span>Copy Client ID</span>
                    </v-tooltip>
                  </li>
                  <li>Tap the menu button <v-icon small>mdi-dots-vertical</v-icon> in the top-right corner</li>
                  <li>Tap "Install app" or "Add to Home screen"</li>
                  <li>Tap "Install" to confirm</li>
                  <li>The app will appear on your home screen</li>
                </ol>
              </v-card-text>
            </v-card>
            
            <v-card flat>
              <v-slide-group
                v-model="androidStep"
                class="pa-0"
                show-arrows
              >
                <v-slide-item
                  v-for="n in 4"
                  :key="n"
                  v-slot="{ toggle }"
                >
                  <div 
                    class="mx-1 step-image-container"
                    @click="toggle"
                  >
                    <v-img
                      :src="`/source/iphone/${n === 4 ? 5 : n}.jpg`"
                      height="180"
                      width="140"
                      contain
                      class="mx-auto rounded"
                    ></v-img>
                  </div>
                </v-slide-item>
              </v-slide-group>
            </v-card>
          </div>
          
          <div v-else>
            <p class="mb-2">To install this app on your device:</p>
            <ol class="instruction-list mb-2">
              <li>In your browser menu, look for an "Install" or "Add to Home Screen" option</li>
              <li>Follow the on-screen instructions to complete installation</li>
            </ol>
            <v-img
              src="/source/ss.png"
              max-height="180"
              contain
              class="mx-auto"
            ></v-img>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: 'InstallPwaButton',
  data() {
    return {
      deferredPrompt: null,
      showInstallButton: false,
      showInstructions: false,
      isIOS: false,
      isAndroid: false,
      iosStep: 0,
      androidStep: 0
    }
  },
  computed: {
    isAllowedPage() {
      // Only show on allowed PWA pages
      const allowedRoutes = ['DietitianFormSelector', 'Form', 'PromoForm', 'MealplanEbook', 'PromoEbookPage', 'InvitePage', 'SelectPage'];

      // Check if the current route name is in the allowed list
      if (allowedRoutes.includes(this.$route.name)) {
        return true;
      }

      // Check for dynamic routes
      const path = this.$route.path;
      return path.includes('/dietitian-form-selector') ||
        path.includes('/form/') ||
        path.includes('/promoform/') ||
        path.includes('/mealplanebook/') ||
        path.includes('/promoebookpage/') ||
        path.includes('/invite-page/') ||
        path.includes('/select-page') ||
        path.includes('/invite');
    },
    isOnEdge() {
      // Check if we're on Edge mobile browser on iOS
      const userAgent = navigator.userAgent;
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      const isEdge = /Edg|Edge/.test(userAgent);
      return isIOS && isEdge;
    }
  },
  props: {
    folderId: {
      type: String,
      default: ''
    }
  },
  mounted() {
    // Detect platform
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.isAndroid = /Android/.test(navigator.userAgent);

    // Listen for the beforeinstallprompt event
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Store the event so it can be triggered later
      this.deferredPrompt = e;
      // Show the install button
      this.showInstallButton = true;
    });

    // Hide the install button when the app is installed
    window.addEventListener('appinstalled', () => {
      console.log('PWA was installed');
      this.showInstallButton = false;
      this.deferredPrompt = null;

      // Show a success message
      this.$store.dispatch('showSuccess', 'App installed successfully!');
    });

    // Check if the app is already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      this.showInstallButton = false;
    }

    // For iOS devices, which don't support beforeinstallprompt
    if (this.isIOS && !window.matchMedia('(display-mode: standalone)').matches) {
      this.showInstallButton = true;
    }
  },
  methods: {
    async installPwa() {
      // If no install prompt is available (like on iOS), just show instructions
      if (!this.deferredPrompt) {
        this.showInstructions = true;
        return;
      }

      try {
        // Show the install prompt
        this.deferredPrompt.prompt();

        // Wait for the user to respond to the prompt
        const { outcome } = await this.deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);

        // Hide the button if installation was accepted
        if (outcome === 'accepted') {
          this.showInstallButton = false;
        }
      } catch (error) {
        console.error('Error during PWA installation:', error);
      } finally {
        // Always clear the prompt after use, regardless of outcome
        this.deferredPrompt = null;
      }
    },
    copyFolderID(text) {
      navigator.clipboard.writeText(text);
      this.$store.dispatch('showSuccess', 'Client ID copied to clipboard');
    },
  }
}
</script>

<style scoped>
.install-pwa-btn {
  animation: pulse 2s infinite;
  font-weight: bold;
}

.install-dialog-bottom {
  max-height: 70vh;
}

.install-dialog-card {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
}

.instruction-list {
  padding-left: 20px;
  margin-bottom: 0;
}

.instruction-list li {
  margin-bottom: 4px;
  font-size: 14px;
}

.step-card {
  transition: all 0.2s ease-in-out;
}

.step-card:hover {
  transform: scale(1.05);
}

.step-image-container {
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 1px;
}

.step-image-container:hover {
  transform: scale(1.05);
}


@media (max-width: 600px) {
  .instruction-list li {
    font-size: 13px;
    margin-bottom: 2px;
  }

  .step-card {
    width: 120px;
    height: 170px;
  }

  .step-image-container {
    padding: 1px;
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.4);
  }

  70% {
    box-shadow: 0 0 0 8px rgba(33, 150, 243, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0);
  }
}
</style> 